const state = {
    type: null,
    message: null,
};

const actions = {
    success ({ commit }, { message, timeout = 1500 }) {
        commit('success', message);

        return new Promise((resolve) => {
            // check for timeout
            if (timeout > 0)
            {
                // resolve the promise after timeout
                setTimeout(() => {
                    // clear the alert
                    commit('clear');

                    // resolve the promise
                    resolve();
                }, timeout);
            }
            else
            {
                // clear the alert
                commit('clear');

                // resolve the promise immediatly
                resolve();
            }
        });
    },
    error ({ commit }, { error, timeout = 4000 }) {
        commit('error', error);

        return new Promise((resolve) => {
            // check for timeout
            if (timeout > 0)
            {
                // resolve the promise after timeout
                setTimeout(() => {
                    // clear the alert
                    commit('clear');

                    // resolve the promise
                    resolve();
                }, timeout);
            }
            else
            {
                // clear the alert
                commit('clear');

                // resolve the promise immediatly
                resolve();
            }
        });
    },
    clear ({ commit }) {
        commit('clear');
    },
};

const mutations = {
    success (state, message) {
        state.type = 'success';
        state.message = message;
    },
    error (state, error) {
        state.type = 'error';

        if (!error.response)
        {
            state.message = 'Er ging iets mis met de API';
            return;
        }

        if (error.response.status === 500 || error.response.status === 501 || error.response.status === 405)
        {
            state.message = `${error.response.statusText}: Er ging iets mis met de API`;
            return;
        }

        if (error.response.status === 404)
        {
            state.message = `${error.response.data.message}: ${error.request.responseURL}`;
            return;
        }

        if (error.response.status === 422 && error.request)
        {
            state.message = `${error.response.data.message}: ${error.request.responseURL}`;
            return;
        }

        if (error.response.data.data)
        {
            if (typeof error.response.data.data === 'object')
            {
                // check for object
                if (Object.values(error.response.data.data).length)
                {
                    const errorData = error.response.data.data;

                    if (errorData.Melding)
                    {
                        state.message = `${errorData.Melding}`;
                    }

                    if (errorData.Message && error.response.status === 401)
                    {
                        state.message = 'De sessie is verlopen, je word vanwege veiligheidsredenen uitgelogd';
                    }
                }

                // check for object array
                if (error.response.data.data.length)
                {
                    const errors = [];

                    for (const node in error.response.data.data)
                    {
                        if ({}.hasOwnProperty.call(error.response.data.data, node))
                        {
                            const item = error.response.data.data[node];
                            errors.push(`${item.Veldnaam}: ${item.Melding}`);
                        }
                    }

                    state.message = errors.join(' ');
                }
            }
        }
        else if (error.response.data)
        {
            const errors = [];

            for (const node in error.response.data)
            {
                if ({}.hasOwnProperty.call(error.response.data, node))
                {
                    const item = error.response.data[node];
                    errors.push(`${item.Veldnaam}: ${item.Melding}`);
                }
            }

            state.message = errors.join(' ');
        }
        else if (error.request)
        {
            state.message = `${error.response.statusText}: Kon niet verbinden met de API`;
        }
        else
        {
            state.message = error.message;
        }
    },
    clear (state) {
        state.type = null;
        state.message = null;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
